var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo col-md-12 text-center mb-5"},[(_vm.$route.name !== 'home' && _vm.system_settings.logo.length >0)?_c('img',{attrs:{"src":_vm.system_settings.logo,"height":"80"}}):_vm._e(),(_vm.$route.name === 'home' && _vm.system_settings.logo.length >0)?_c('img',{attrs:{"src":_vm.system_settings.logo,"height":"150"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }